import React from 'react';
import Plot2D from '../../Result/Public/waveform/Plot2D';
import { getVoltageDisplay } from './measurementHelper';
import { I2C } from '../../PCBHelper/constants';
import { RESULT_TREE_SIGNAL } from '../../../pages/Sierra/result/components/resultTreeRender';

function Signal() {
  this.name = null; // String, name of the signal
  this.type = null; // String, signal type - 'voltage' or 'current'
};

// ------ Result data class ------
/** Raw curve data of a byte */
class WaveformData {
  constructor() {
    this.signals = []; // Array of WaveformResultHelper.Signal, list of signal description
    this.time = []; // Array of Number, time instances of the simulation
    this.curveData = []; // Array of Array of Number, values at each time instance for all signals
    this.plot = null;
  }

  getCurves() {
    return this.plot.curves;
  }

  parseRawCurve(fileContent) {
    // break the file into lines
    if (!fileContent) {
      return;
    }
    var lineBuffer = fileContent.match(/[^\r\n]+/g);
    if (!lineBuffer || (Array.isArray(lineBuffer) && !lineBuffer.length)) {
      this.signals = [];
      this.time = [];
      this.curveData = [];
      return;
    }
    // read the header
    var numSignals = 0; // number of signals in the raw data file
    var numPoints = 0; // number of sampling points in the raw data file
    var indDataLine = 0; // starting line of the curve data
    var isReadingSignalDef = false; // indicator of the signal definition section in the header

    for (let i = 0; i < lineBuffer.length; i++) {

      if (isReadingSignalDef) {

        // get the name and type of the signal
        var words = lineBuffer[i].trim().split("\t");

        var signalItem = new Signal();
        signalItem.name = words[1];
        signalItem.type = words[2];
        this.signals.push(signalItem);

        // add a data line for the signal
        this.curveData.push([]);

        if (this.signals.length === numSignals)
          isReadingSignalDef = false;
      } else {

        words = lineBuffer[i].split(" ");
        if (words[0] === 'No.' && words[1] === 'Variables:') {
          // number of signals
          numSignals = Number(words[2]);
        } else if (words[0] === 'No.' && words[1] === 'Points:') {
          // number of points
          numPoints = Number(words[2]);
        } else if (words[0] === 'Variables:') {
          // starting of variable definitions
          isReadingSignalDef = true;
        } else if (words[0] === 'Values:') {
          // starting of curve values
          indDataLine = Number(i);
          break;
        }
      }
    } // for (var i in lineBuffer)

    // data integrity check
    if (numPoints <= 0 || numSignals <= 0 || this.signals.length !== numSignals)
      return null;
    else if (indDataLine + numSignals * numPoints >= lineBuffer.length)
      return null;

    // read the data points
    try {
      for (var iPoint = 0; iPoint < numPoints; iPoint++) {

        for (var iSignal = 0; iSignal < numSignals; iSignal++) {

          indDataLine++;
          if (iSignal === 0) {
            words = lineBuffer[indDataLine].split('\t');
            /* this.curveData[iSignal].push(Number(words[2])); */
            this.curveData[iSignal].push(Number(words[words.length - 1]));
          } else {
            this.curveData[iSignal].push(Number(lineBuffer[indDataLine]));
          }

        } // for (var iSignal = 0; iSignal < numSignals; iSignal++)
      } // for (var iPoint = 0; iPoint < numPoints; iPoint++)

      // separate the time signal
      this.time = this.curveData.shift();
      this.signals.shift();

    } catch (err) {
      this.signals = [];
      this.time = [];
      this.curveData = [];
    }
  } // parseRawCurveFile

  /** ------ implementation of WaveformResultHelper.plotWaveform ------
  *  Draw the raw curves
  *  @param  svgElement   - the SVG element where the plot is added
  *  @param  rawCurveData - a WaveformResultHelper.WaveformData object, containing the curve data of a byte
  *  @return a WaveformResultHelper.Plot object with a handle to the plot
  */
  plotWaveform = ({ svgElement, ui = 1e-9, events }) => {
    if (this.plot === null) {
      const { PlotOptions, CurveItem } = Plot2D;
      // plot options
      const plotOptions = new PlotOptions();
      plotOptions.xUnit = 's';
      plotOptions.yUnit = 'V';
      plotOptions.grid = 'xy';
      plotOptions.zoom = 'x';
      plotOptions.xLabel = 'Time';
      plotOptions.yLabel = 'Voltage';
      plotOptions.ui = ui; //unit interval - approximate data cycle length
      this.plot = new Plot2D(svgElement, plotOptions, events, 'sierra');
      const { signals, plot, time, curveData } = this;
      // prepare the curve data
      var curves = [];
      for (let i = 0; i < signals.length; i++) {
        const signal = signals[i];
        if (signal.name) {
          let newCurve = new CurveItem();
          newCurve.x = time;
          newCurve.y = curveData[i];
          newCurve.name = signal.name;
          curves.push(newCurve);
        }
      }

      // display the curves
      plot.plotCurves(curves);
    } else {
      this.plot.redrawPlot(svgElement);
    }
  } // plotWaveform


  updataRawCurvePlot = () => {
    this.plot.updatePlot();
  }

  getCurvesData = () => {
    const { signals, time, curveData } = this;
    const { CurveItem } = Plot2D;
    // prepare the curve data
    var curves = [];
    for (let i = 0; i < signals.length; i++) {
      const signal = signals[i];
      if (signal.name) {
        let newCurve = new CurveItem();
        newCurve.x = time;
        newCurve.y = curveData[i];
        newCurve.name = signal.name;
        curves.push(newCurve);
      }
    }

    return curves;
  }
};

export function getDataList(compInfo) {
  let list = [], show = [], portSelect = {}, openSignal = "", allPortSelect = {}, compPinGroupObj = {};
  const _compInfo = compInfo.filter(item => item.usage);
  for (let item of _compInfo) {
    const { color, component, pin, pcb, experiment, signal, usage, pkg, ndEn, curveIndex, postProcessData, designName } = item;

    let name = `${component} - ${pin}`, title = `${experiment} ${signal} ${designName} ${component}-${pin} ${usage}`;
    let id = `${experiment}@${name}-${pcb}-${usage}-${signal}`;
    let displayTitle = <div>{experiment} {signal} <span className="post-process-title-comp">{designName} {component}-{pin}</span> {usage}</div>
    if (pkg) {
      id = `${id}-pkg`;
      name = `${component} - ${pin} - Die`;
      title = `${experiment} ${signal} ${designName} ${component}-${pin}-Die ${usage}`;
      displayTitle = <div>{experiment} {signal} <span className="post-process-title-comp">{designName} {component}-{pin}-Die</span> {usage}</div>
    };
    if (ndEn) { id = `${id}-nden` };

    postProcessData.curveName = id;
    postProcessData.title = title;
    //only ic driver/receiver/connector/repeater have post process
    let _postProcessData = !["Driver", "Receiver", "Repeater", "Connector"].includes(usage) ? {} : { ...postProcessData, signal, displayTitle }
    const findRow = list.find(l => l.rowName === signal);
    const children = {
      id,
      name,
      usage,
      pkg,
      ndEn,
      pcb,
      color: { [experiment]: color },
      curveIndex: { [experiment]: curveIndex },
      postProcessData: _postProcessData,
      expPostProcessData: { [experiment]: _postProcessData },
      type: "resultTreeSweepPin",
      parentKey: signal,
      notShowPcbName: true,
      className: "result-waveform-tree-node-title",
    }
    if (!compPinGroupObj[`${name}-${pcb}-${usage}-${signal}`]) {
      compPinGroupObj[`${name}-${pcb}-${usage}-${signal}`] = []
    }
    compPinGroupObj[`${name}-${pcb}-${usage}-${signal}`].push(experiment)
    if (!findRow) {
      list.push({ rowName: signal, groupName: [experiment], id: signal, title: signal, className: "result-waveform-tree-signal-node-title", type: RESULT_TREE_SIGNAL, children: [children] });
      allPortSelect[signal] = [id]
      if (!openSignal) {
        openSignal = signal;
        portSelect[signal] = [id]
      }
      show.push(signal)
    } else {
      const findChild = findRow.children.find(child => child.name === name && child.usage === usage && pcb === child.pcb);
      let add = true;
      if (!findChild || pkg !== findChild.pkg) {
        add = false;
      }
      if (add) {
        findChild.color[experiment] = color;
        findChild.curveIndex[experiment] = curveIndex;
        findChild.expPostProcessData[experiment] = _postProcessData
      } else {
        findRow.children.push(children)
      }
      findRow.groupName = [...new Set([...findRow.groupName, experiment])];
      allPortSelect[signal].push(id)
      if (signal === openSignal) {
        portSelect[signal].push(id)
      }
    }
    item.portSelectId = id;
  }
  return { _compInfo: compInfo, dataList: { Waveform: { list, show } }, portSelect, allPortSelect, compPinGroupObj }
}

export function getVerificationDataList(compInfo, hasVictim, signalNameObj) {
  let list = [], show = [], portSelect = {}, openSignal = "", victimList = [], victimShow = [];
  const _compInfo = compInfo.filter(item => item.usage)
  for (let item of _compInfo) {
    const { color, component, pin, pcb, signal, usage, pkg, ndEn, curveIndex, curveName, postProcessData, designName } = item;
    let name = `${component} - ${pin}`, title = `${signal} ${designName} ${component}-${pin} ${usage}`;
    let displayTitle = <div>{signal} <span className="post-process-title-comp" >{designName} {component}-{pin}</span> {usage}</div>
    if (pkg) {
      name = `${component} - ${pin} - Die`;
      title = `${signal} ${designName} ${component}-${pin}-Die ${usage}`;
      displayTitle = <div>{signal} <span className="post-process-title-comp" >{designName} {component}-{pin}-Die</span> {usage}</div>
    }
    // only ic driver/receiver/connector/repeater have post process
    let _postProcessData = !["Driver", "Receiver", "Repeater", "Connector"].includes(usage) ? {} : { ...postProcessData, title, signal, displayTitle }
    let id = curveName;

    function getDataListChildrenInfo(paramList) {
      const findRow = paramList.find(l => l.rowName === signal);
      const children = {
        id,
        name,
        usage,
        pkg,
        ndEn,
        pcb,
        notShowPcbName: true,
        color,
        curveIndex,
        postProcessData: _postProcessData,
        type: "waveformPin",
        parentKey: signal,
        className: "result-waveform-tree-node-title"
      }

      return { findRow, children };
    }
    if (hasVictim && signalNameObj[signal] && signalNameObj[signal].isVictim) {
      const { findRow, children } = getDataListChildrenInfo(victimList);
      if (!findRow) {
        const nets = signalNameObj[signal] && signalNameObj[signal].nets ? signalNameObj[signal].nets : [];
        victimList.push({
          rowName: signal,
          id: signal,
          title: `${signal} ${nets && nets.length ? "(" + nets.join(",") + ")" : ""}`,
          type: RESULT_TREE_SIGNAL,
          className: "result-waveform-tree-signal-node-title",
          children: [children]
        });
        victimShow.push(signal);
        if (!openSignal) {
          openSignal = signal;
          portSelect[signal] = [id]
        }
      } else {
        findRow.children.push(children)
        if (signal === openSignal) {
          portSelect[signal].push(id)
        }
      }
    } else {
      const { findRow, children } = getDataListChildrenInfo(list);
      if (!findRow) {
        list.push({ rowName: signal, id: signal, title: signal, type: RESULT_TREE_SIGNAL, className: "result-waveform-tree-signal-node-title", children: [children] });
        show.push(signal);
        if (!openSignal) {
          openSignal = signal;
          portSelect[signal] = [id]
        }
      } else {
        findRow.children.push(children)
        if (signal === openSignal) {
          portSelect[signal].push(id)
        }
      }
    }

    item.portSelectId = id;
  }

  if (hasVictim) {
    const signalNames = Object.keys(signalNameObj);
    victimList.sort((a, b) => signalNames.indexOf(a.id) - signalNames.indexOf(b.rowName))
  }

  return { _compInfo: compInfo, dataList: { Waveform: { list, show } }, portSelect, victimDataList: { Waveform: { list: victimList, show: victimShow } } }
}

export function judgePostProcessSignalType(data, config) {
  let _data = {}
  if (!data || !config) {
    return _data;
  }
  const keys = Object.keys(data)
  const { pcbs, timing } = config;
  const clockPins = timing.map(item => item.clock_pin)
  const resultList = keys.map(key => data[key]);
  for (let key of keys) {
    const postProcessData = data[key];
    if (!postProcessData || !postProcessData.edgesInfo) {
      _data[key] = data[key];
      continue;
    }
    const { component, pcb, pin } = postProcessData.edgesInfo;

    const currentPCB = pcbs.find(item => item.name === pcb);
    if (!currentPCB) {
      _data[key] = data[key];
      continue;
    }

    const currentComponent = currentPCB.components.find(item => item.name === component);
    if (!currentComponent) {
      _data[key] = data[key];
      continue;
    }

    const currentPin = currentComponent.pins.find(item => item.name === pin);
    if (!currentPin) {
      _data[key] = data[key];
      continue;
    }

    const pinId = currentPin.id;

    const isCLK = clockPins.includes(pinId);
    const findTiming = timing.find(item => item.signal_pins && item.signal_pins.includes(pinId));
    let clkPinId = findTiming && findTiming.clock_pin ? findTiming.clock_pin : null;
    let clkPinWaveformSignal = null;
    if (!isCLK && clkPinId) {
      const clkPin = currentComponent.pins.find(item => item.id === clkPinId);
      const findWaveform = clkPin ? resultList.find(it => it.edgesInfo.pcb === pcb && it.edgesInfo.component === currentComponent.name && it.edgesInfo.pin === clkPin.name) : null;
      clkPinWaveformSignal = findWaveform && findWaveform.edgesInfo ? findWaveform.edgesInfo.waveform_signal : null;
    }
    _data[key] = { ...postProcessData, isCLK, clkPinWaveformSignal }

  }
  return _data;
}

export const INDEX = 'index', TIME_RISING = 'timeRising', TIME_FALLING = 'timeFalling', DOUBLE_EDGE = 'doubleEdgeFalling',
  SETUP_TIME = 'setup_time', HOLD_TIME = 'hold_time', VALID_TIME = "valid_time",
  OVER_SHOOT = 'overshoot', UNDER_SHOOT = 'undershoot',
  HIGH_TIME = 'high_time', LOW_TIME = 'low_time';
const basicColumns = [{
  title: 'Index',
  dataIndex: INDEX,
  key: INDEX,
  width: "8%",
}, {
  title: 'Rising Time',
  dataIndex: TIME_RISING,
  key: TIME_RISING,
  width: '16%',
  // sorter: (a, b) => a.risingTimeDifference - b.risingTimeDifference,
}, {
  title: 'Falling Time',
  dataIndex: TIME_FALLING,
  width: '16%',
  key: TIME_FALLING,
}]
const notCLKColumns = [{
  title: 'Setup Time',
  dataIndex: SETUP_TIME,
  key: SETUP_TIME,
  width: '13%',
}, {
  title: 'Hold Time',
  dataIndex: HOLD_TIME,
  key: HOLD_TIME,
  width: '13%',
}];
const valid_column = {
  title: 'Valid Time',
  dataIndex: VALID_TIME,
  key: VALID_TIME,
  width: '13%',
};
const shootColumns = [{
  title: 'Overshoot (V)',
  dataIndex: OVER_SHOOT,
  key: OVER_SHOOT,
  width: '12%',
}, {
  title: 'Undershoot (V)',
  dataIndex: UNDER_SHOOT,
  key: UNDER_SHOOT,
  width: '12%'
}]
const highLowColumns = [{
  title: 'High Time',
  dataIndex: HIGH_TIME,
  key: HIGH_TIME,
  width: '13%',
}, {
  title: 'Low Time',
  dataIndex: LOW_TIME,
  key: LOW_TIME,
  width: '13%'
}];
const doubleEdgeColumn = {
  title: 'Double Edge (V)',
  dataIndex: DOUBLE_EDGE,
  key: DOUBLE_EDGE,
  width: '12%',
}

export const timeUnitList = [TIME_RISING, TIME_FALLING, SETUP_TIME, HOLD_TIME, HIGH_TIME, LOW_TIME, VALID_TIME];
export const timeValueList = [SETUP_TIME, HOLD_TIME, HIGH_TIME, LOW_TIME, VALID_TIME, 'risingTimeDifference', 'fallingTimeDifference'];
export const timeArrayList = [TIME_RISING, TIME_FALLING];

export function getEdgesColumns({ isCLK, doubleEdgeExist, interfaceTag, isShowSHTime }) {
  const _basicColumns = doubleEdgeExist ? [...basicColumns, doubleEdgeColumn] : basicColumns;
  let columns = isCLK ?
    JSON.parse(JSON.stringify([..._basicColumns, ...highLowColumns, ...shootColumns]))
    : JSON.parse(JSON.stringify(interfaceTag === I2C && isShowSHTime ? [..._basicColumns, ...notCLKColumns, valid_column, ...shootColumns] : [..._basicColumns, /* ...notCLKColumns, */ ...shootColumns]));

  return columns
}

function getTimeMinMaxAndSpec({
  dataIndex,
  isShowRisingSpec,
  isShowFallingSpec,
  isShowSetupSpec,
  isShowHoldSpec,
  isShowValidSpec,
  minRising,
  maxRising,
  minFalling,
  maxFalling,
  minSetup,
  maxSetup,
  minHold,
  maxHold,
  minValid,
  maxValid }) {
  switch (dataIndex) {
    case TIME_RISING:
      return { min: minRising, max: maxRising, isShowSpec: isShowRisingSpec };
    case TIME_FALLING:
      return { min: minFalling, max: maxFalling, isShowSpec: isShowFallingSpec }
    case SETUP_TIME:
      return { min: minSetup, max: maxSetup, isShowSpec: isShowSetupSpec }
    case HOLD_TIME:
      return { min: minHold, max: maxHold, isShowSpec: isShowHoldSpec }
    case VALID_TIME:
      return { min: minValid, max: maxValid, isShowSpec: isShowValidSpec }
    default: return {}
  }
}

export function getTitle(key) {
  switch (key) {
    case TIME_RISING:
      return 'Rising Time';
    case TIME_FALLING:
      return 'Falling Time';
    case DOUBLE_EDGE:
      return 'Double Edge';
    case HOLD_TIME:
      return 'Hold Time';
    case VALID_TIME:
      return "Valid Time";
    case SETUP_TIME:
      return 'Setup Time';
    case OVER_SHOOT:
      return 'Overshoot';
    case UNDER_SHOOT:
      return 'Undershoot';
    case HIGH_TIME:
      return 'High Time';
    case LOW_TIME:
      return 'Low Time'
    default: return key;
  }
}

function getArrayValueByKey(key) {
  switch (key) {
    case TIME_RISING:
      return 'risingTimeDifference';
    case TIME_FALLING:
      return 'fallingTimeDifference';
    case DOUBLE_EDGE:
      return 'doubleEdgeFallingDifference';
    default: return null;
  }
}

export const SPEC = 'spec', V_HIGH = 'vHigh', V_LOW = 'vLow', V_HIGH_ACTUAL = 'actual_vHigh', V_LOW_ACTUAL = 'actual_vLow'
// Displays the spec and current for vHigh/Vlow, and the spec for rising and falling are highlighted in red in the previous table
export const specTableColumns = [
  {
    title: 'Spec',
    dataIndex: SPEC,
    key: SPEC,
    width: '24%'
  }, {
    title: 'V High (Spec)',
    dataIndex: V_HIGH,
    key: V_HIGH,
    width: '18%',
    render: (value = [], record) => {
      const _value = value || [];
      return value && value.length ? <span>[{getVoltageDisplay(_value[0], true)}, {getVoltageDisplay(_value[1], true)}]</span> : null
    }
  }, {
    title: 'V Low (Spec)',
    dataIndex: V_LOW,
    key: V_LOW,
    width: '18%',
    render: (value = [], record) => {
      const _value = value || [];
      return value && value.length ? <span>[{getVoltageDisplay(_value[0], true)}, {getVoltageDisplay(_value[1], true)}]</span> : null
    }
  }, {
    title: 'V High (Actual)',
    dataIndex: V_HIGH_ACTUAL,
    key: V_HIGH_ACTUAL,
    width: '20%',
  }, {
    title: 'V Low (Actual)',
    dataIndex: V_LOW_ACTUAL,
    key: V_LOW_ACTUAL,
    width: '20%',
  }
]

export function getSpecPinInfo(postProcessConfig = {}, edgesInfo = {}) {
  const { pcbs = [] } = postProcessConfig;
  const { pcb, component, pin } = edgesInfo;
  const pcbIndex = pcbs.findIndex(it => it.name === pcb);
  if (pcbIndex > -1) {
    const compIndex = (pcbs[pcbIndex].components || []).findIndex(it => it.name === component);
    if (compIndex > -1) {
      const pinIndex = (pcbs[pcbIndex].components[compIndex].pins || []).findIndex(it => it.name === pin);
      if (pinIndex > -1) {
        const pinInfo = pcbs[pcbIndex].components[compIndex].pins[pinIndex] || {};
        return {
          ...(pinInfo.spec || {}),
          [V_HIGH_ACTUAL]: pinInfo[V_HIGH_ACTUAL],
          [V_LOW_ACTUAL]: pinInfo[V_LOW_ACTUAL],
          vdd: pinInfo.vdd,
          spec: (pinInfo.spec || {})
        }
      }
    }
  }

  return {};
}

export {
  getTimeMinMaxAndSpec,
  getArrayValueByKey
}

export default WaveformData;